
import { isObject } from 'vessel/utils'

export default {
  name: 'VsLink',
  props: {
    to: {
      type: [String, Object],
      default: null
    },
    href: {
      type: String,
      default: null
    },
    scheme: {
      type: String,
      default() {
        return this.href && this.href.split(':')[0]
      }
    },
    lon: {
      type: [Number, String],
      default: null
    },
    lat: {
      type: [Number, String],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    button: {
      type: [Boolean, Object],
      default: false
    }
  },
  vessel: {
    link: {
      $attrs: 'all',
      $disabled: {
        opacity(val) {
          return val ? 50 : null
        },
        pointerEvents(val) {
          return val ? 'none' : null
        }
      }
    },
    button: {
      $attrs: 'all',
      $disabled: {
        pointerEvents(val) {
          return val ? 'none' : null
        }
      }
    }
  },
  computed: {
    tag() {
      const component = this.$nuxt ? 'nuxt-link' : 'router-link'
      return this.to ? component : 'a'
    },
    isHttp() {
      return this.scheme && this.scheme.startsWith('http')
    },
    geoPath() {
      return this.scheme == 'geo' && `${this.lat},${this.lon}`
    },
    path() {
      const path = this.href && this.href.replace(/^\w+:(\/+)?|\s/g, '')
      return this.isHttp ? `//${path}` : path
    },
    url() {
      const path = this.geoPath || this.path
      return this.scheme && path ? `${this.scheme}:${path}` : null
    },
    linkAttrs() {
      const href   = this.url
      const rel    = 'nofollow, noreferrer'
      const target = '_blank'

      return this.isHttp ? { href, rel, target } : { href }
    },
    routerAttrs() {
      return {
        to: this.to
      }
    },
    attrs() {
      const attrs = this.to ? this.routerAttrs : this.linkAttrs
      return { ...this.$attrs, ...attrs }
    },
    isButton() {
      return this.button !== false
    },
    buttonClasses() {
      const props = {
        type: 'default',
        size: null,
        plain: false,
        round: false,
        circle: false,
        square: false
      }

      if (isObject(this.button)) {
        Object.assign(props, this.button)
      }

      return {
        'el-button': true,
        [`el-button--${props.type}`]: !!props.type,
        [`el-button--${props.size}`]: !!props.size,
        'is-disabled': this.disabled,
        'is-plain': props.plain,
        'is-round': props.round,
        'is-circle': props.circle || props.square,
        'is-square': props.square,
        ...this.$vessels.button
      }
    }
  }
}
